/**
 * RegionContextLine — Phase 1B
 *
 * One-line regional/distance cue rendered on job cards and job detail pages.
 *
 *     "Nearby from your home · Bluffton, SC"
 *
 * Client-side bucketing of an already-present `distance_miles` field.
 * No new API call. No map. No tooltip. Muted, single line.
 */

const BAND_THRESHOLDS = [
  { max: 15, label: 'Local' },
  { max: 40, label: 'Nearby' },
  { max: 100, label: 'Regional' },
  { max: Infinity, label: 'Distant' },
];

export function distanceBand(distanceMiles) {
  if (distanceMiles == null || !isFinite(distanceMiles)) return null;
  for (const t of BAND_THRESHOLDS) {
    if (distanceMiles <= t.max) return t.label;
  }
  return null;
}

export function RegionContextLine({
  distanceMiles,
  city,
  remote = false,
  testId,
  className = '',
}) {
  // Remote roles have no meaningful distance band.
  if (remote) return null;

  const band = distanceBand(distanceMiles);
  // Spec requires the band prefix; if we cannot compute one, render nothing
  // rather than a half-formed city-only line.
  if (!band) return null;

  return (
    <p
      data-testid={testId}
      className={`text-xs text-slate-400 ${className}`}
    >
      {city ? `${band} from your home \u00B7 ${city}` : `${band} from your home`}
    </p>
  );
}

export default RegionContextLine;
